import {
    AppWidgetState,
    BaseWidgetRequest,
    UpdateSummaryWidgetRequest,
    UpdateVisualizationWidgetRequest,
    UpdateWidgetRequest,
} from '@ddv/models';

import { getFilters } from './get-filters';
import { getFunds } from './get-funds';
import { getSummaryConfig } from './get-summary-config';
import { getVisualizationConfigs } from './get-visualization-configs';

export function convertToUpdateWidgetRequest(coreWidgetConfig: AppWidgetState): UpdateWidgetRequest {
    if (coreWidgetConfig.coreWidgetType === 'SUMMARY') {
        return getUpdateSummaryWidgetRequest(coreWidgetConfig);
    }

    return getUpdateVisualizationWidgetRequest(coreWidgetConfig);
}

function getUpdateSummaryWidgetRequest(coreWidgetConfig: AppWidgetState): UpdateSummaryWidgetRequest {
    return {
        ...getBaseWidgetRequest(coreWidgetConfig),
        coreWidgetType: 'SUMMARY',
        summaryConfig: getSummaryConfig(coreWidgetConfig.summaryConfig),
    };
}

function getUpdateVisualizationWidgetRequest(coreWidgetConfig: AppWidgetState): UpdateVisualizationWidgetRequest {
    return {
        ...getBaseWidgetRequest(coreWidgetConfig),
        coreWidgetType: 'VISUALIZATION',
        visualizationConfigs: getVisualizationConfigs(coreWidgetConfig.visualizationConfigs),
    };
}

function getBaseWidgetRequest(coreWidgetConfig: AppWidgetState): BaseWidgetRequest & { version: number } {
    return {
        name: coreWidgetConfig.name,
        description: coreWidgetConfig.description,
        customDisplayName: coreWidgetConfig.customDisplayName ?? null,
        displayNameType: coreWidgetConfig.displayNameType ?? 'AUTO',
        enableWidgetHeader: !!coreWidgetConfig.enableWidgetHeader,
        isSelectable: !!coreWidgetConfig.isSelectable,
        isShared: !!coreWidgetConfig.isShared,
        namedQueryId: coreWidgetConfig.namedQueryId,
        version: coreWidgetConfig.version,
        sharing: coreWidgetConfig.sharing,
        widgetFilters: {
            funds: getFunds(coreWidgetConfig.widgetFilters?.funds ?? []),
            clients: coreWidgetConfig.widgetFilters?.clients ?? [],
            filters: getFilters(coreWidgetConfig.widgetFilters?.filters ?? []),
            startDate: coreWidgetConfig.widgetFilters?.startDate ?? '',
            endDate: coreWidgetConfig.widgetFilters?.endDate ?? '',
            activeDate: coreWidgetConfig.widgetFilters?.activeDate ?? null,
        },
        widgetSettings: {
            isSubscribedToDashboardFilters: !!coreWidgetConfig.isSubscribedToDashboardFilters,
            isActiveDate: !!coreWidgetConfig.isActiveDate,
        },
    };
}
